module.exports = __webpack_public_path__ + "images/application/illustrations/inbox-923d334c.svg";